module.exports = __webpack_public_path__ + "img/topicPersonalCare.9a8ea834.webp";